import store from '../store';
import { ERRORS_ADD_ERROR } from '../store/errors';

export interface InterfaceLogger {
  info(msg: any): any;
  warn(msg: any): any;
  error(msg: any, err: Error): any;
}

class Logger implements InterfaceLogger {
  public info(msg: any) {    
    // eslint-disable-next-line
    console.info(msg);
  }

  public warn(msg: any) {    
    // eslint-disable-next-line
    console.warn(msg);
  }

  public error(msg: any, err: Error) {
    // eslint-disable-next-line
    console.error(msg, err);
    store.dispatch(ERRORS_ADD_ERROR, err);
  }
}

export default new Logger();
